import type { Document, DocumentAssociation, DocumentFileLink, DocumentList, Documents } from '#domain/Document.ts';

import type {
    ApiDocument,
    ApiDocumentAssociation,
    ApiDocumentList,
    ApiDocuments,
    ApiWriteDocument,
} from '../model/types.ts';

export const mapDocumentAssociation = (association: ApiDocumentAssociation): DocumentAssociation | null => {
    if (!association.type || !association.id) {
        return null;
    }

    return {
        type: association.type,
        id: association.id,
    };
};

export const mapDocument = (document: ApiDocument): Document => ({
    id: document.id,
    type: document.type,
    name: document.name,
    fileName: document.file_name,
    externalId: document.file_id,
    origin: document.origin ?? 'unknown',
    associations: document.associations
        ?.map(mapDocumentAssociation)
        .filter((association): association is DocumentAssociation => association !== null),
});

export const mapDocuments = (documents: ApiDocuments): Documents => documents.map(mapDocument);

export const mapDocumentList = (list: ApiDocumentList): DocumentList => ({
    items: list.items ? mapDocuments(list.items) : [],
});

export const mapDocumentToWriteDocument = (document: Document): ApiWriteDocument => ({
    type: document.type,
    name: document.name,
    file_id: document.externalId || document.id,
    file_name: document.fileName,
});

export const mapDocumentFileLink = (link: { url: string }): DocumentFileLink => ({
    url: link.url,
});
